import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const GET_CASE_LIST_FOR_PAGE = "GET_CASE_LIST_FOR_PAGE";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetExternalAuditCases`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASE_LIST_FOR_PAGE, service, mock);
